export const DOCUMENT_TYPES = {
  "ES" : [{value:"DNI"}, {value:"NIE"}, {value:"Passport"}],
  "PT" : [{value:"CC"}, {value:"BI"}, {value:"Passport"}],
  "IT" : [{value:"CIE"}, {value:"Passport"}],
  "FR" : [{value:"CNI"}, {value:"Passport"}]
};